import { call, takeEvery } from 'redux-saga/effects'

import { sendAuthenticatedGetRequestToAPI } from 'modules/generators/requestsToAPI'

export const GET_VISIT_HISTORY_REQUEST = 'VisitHistory/GET_VISIT_HISTORY_REQUEST'
export const GET_VISIT_HISTORY_SUCCESS = 'VisitHistory/GET_VISIT_HISTORY_SUCCESS'
export const GET_VISIT_HISTORY_ERROR = 'VisitHistory/GET_VISIT_HISTORY_ERROR'

export function getVisitHistoryRequest (customerFileId) {
  return {
    type: GET_VISIT_HISTORY_REQUEST,
    payload: customerFileId
  }
}

export function getVisitHistorySuccess (visitHistory) {
  return {
    type: GET_VISIT_HISTORY_SUCCESS,
    payload: visitHistory
  }
}

export function getVisitHistoryError (error) {
  return {
    type: GET_VISIT_HISTORY_ERROR,
    payload: error
  }
}

export function * getVisitHistory (action) {
  const customerFileId = action.payload
  const route = `/murfy-erp/visit-history/${customerFileId}/?include=customer_file`

  yield call(
    sendAuthenticatedGetRequestToAPI,
    route,
    getVisitHistorySuccess,
    getVisitHistoryError
  )
}

export function * getVisitHistorySaga () {
  yield takeEvery(GET_VISIT_HISTORY_REQUEST, getVisitHistory)
}

const initialState = {
  error: null,
  visitHistory: null
}

export function reducer (state = initialState, action) {
  switch (action.type) {
    case GET_VISIT_HISTORY_REQUEST:
      return {
        ...state,
        error: null
      }
    case GET_VISIT_HISTORY_SUCCESS:
      return {
        ...state,
        visitHistory: action.payload,
        error: null
      }
    case GET_VISIT_HISTORY_ERROR:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}

export default reducer
